import {Injectable} from '@angular/core';

import {Observable} from "rxjs";
import {
    IConfigurableTable
} from "libraries/interfaces/i-configurable-table";
import {
    ConfigurationResourceService
} from "libraries/service/resources/configuration/configurationResource.service";
import {IBookingSearchResultConfig} from "libraries/interfaces/IConfigurableTable";

const DEFAULT: IConfigurableTable = {};

@Injectable({providedIn: "root"})
export class BookingListDomainService {

    constructor(
        private readonly configurationResourceService: ConfigurationResourceService,
    ) {
    }

    public getTableConfiguration(): Observable<IBookingSearchResultConfig> {
        return this.configurationResourceService.get(
            ["wui", "app_sasha", "config", "booking-search-result", "booking-search-result.json"],
            DEFAULT
        ) as Observable<IBookingSearchResultConfig>;
    }
}
